module.exports = __webpack_public_path__ + "static/media/wd_page_area04_img_cn.2b51a6cb.png";